/* eslint-disable */
import {AxiosResponse} from 'axios';
import HttpRequest from '@/services/http-request';

export const getCatalogCountries = (): Promise<AxiosResponse> => HttpRequest.get('api/catalogs/address/get/countries');

export const getCatalogStates = (config: any): Promise<AxiosResponse> => HttpRequest.get('api/catalogs/address/get/states', config);

export const getCatalogMunicipalities = (config: any): Promise<AxiosResponse> => HttpRequest.get('api/catalogs/address/get/municipalities', config);
